import React from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  TextField,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const HeaderTable = ({ handleHeaderChange, handleDelete, headers }) => {
  console.log(headers)
  const handleChange = (index, field, value) => {
    handleHeaderChange(index, field, value);
  };

  return (
    <Box sx={{ mt: 1, maxHeight: "200px", overflow: "auto"}}>
      <Table >
        <TableHead>
          <TableRow>
            <TableCell sx={{ p: "2px 2px 2px 16px", border: "1px solid #C0C0C0" }}>
              <Typography fontWeight="bold">Key</Typography>
            </TableCell>
            <TableCell sx={{ p: "2px 2px 2px 16px", border: "1px solid #C0C0C0" }}>
              <Typography fontWeight="bold">Value</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(headers.length === 0 ? [{ key: "", value: ""}] : headers).map((row, index) => (
            <TableRow key={index} hover sx={{ "&:hover .delete-icon": { visibility: "visible" } }}>
              <TableCell sx={{ p: "2px 2px 2px 10px", border: "1px solid #C0C0C0", }}>
                <TextField
                  placeholder="Key"
                  variant="outlined"
                  value={row.key}
                  onChange={(e) => handleChange(index, "key", e.target.value)}
                  fullWidth
                  sx={{
                    height: 25,
                    p: 0,
                    "& .MuiOutlinedInput-root": {
                      padding: 0,
                      fontSize: 12,
                      height: 25,
                      "& fieldset": {
                        border: "none", // no border normally
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "1px solid #979797", // only on focus
                      },
                    },
                    "& input": {
                      height: "100%",
                      padding: "0 6px",
                      fontSize: 12,
                    },
                  }}
                />
              </TableCell>
              <TableCell sx={{ p: "2px 2px 2px 10px", position: "relative", border: "1px solid #C0C0C0" }}>
                <TextField
                  placeholder="Value"
                  variant="outlined"
                  value={row.value}
                  onChange={(e) => handleChange(index, "value", e.target.value)}
                  fullWidth
                  sx={{
                    height: 25,
                    "& .MuiOutlinedInput-root": {
                      padding: 0,
                      fontSize: 12,
                      height: 25,
                      "& fieldset": {
                        border: "none", // no border normally
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "1px solid #979797", // only on focus
                      },
                    },
                    "& input": {
                      height: "100%",
                      padding: "0 6px",
                      fontSize: 12,
                    },
                  }}
                />

                {(row.key || row.value) && (
                  <IconButton
                    onClick={() => handleDelete(index)}
                    size="small"
                    className="delete-icon"
                    sx={{ visibility: "hidden", position: "absolute", right: 0, top: 0, background: "#FFFFFF"}}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default HeaderTable;
